







import Vue from 'vue'
import { getColorContrast } from '@/services/get-color-contrast'

export default Vue.extend({
  name: 'AddressColorCellRenderer',

  computed: {
    getData(): any[] {
      //@ts-ignore
      return this.params.data.farben
    }
  },

  methods: {
    getAddressStyle (item: string | null): Object {
      return {'background-color': `${item ? item : ''}`, 'color': `${getColorContrast(item ? item : '')}`}
    },
  }
})
